import { injectInvoiceV2Api } from '@delmonicos/shared-sdk/libs/emsp/src/clients/redux/back-office/invoice-v2.service';
import { baseApi } from '@service/base.api';

export const invoiceV2Api = injectInvoiceV2Api(baseApi);

export const {
  useGetInvoicesV2PaginatedQuery,
  useGetInvoiceV2Query,
  useDownloadInvoiceV2PdfMutation,
} = invoiceV2Api;
